import { render, staticRenderFns } from "./AppEmailAddressEdit.vue?vue&type=template&id=0ce127a4&scoped=true"
import script from "./AppEmailAddressEdit.vue?vue&type=script&lang=js"
export * from "./AppEmailAddressEdit.vue?vue&type=script&lang=js"
import style0 from "./AppEmailAddressEdit.vue?vue&type=style&index=0&id=0ce127a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce127a4",
  null
  
)

export default component.exports